<template>
  <div class="complaint_manage">
    <div class="title" @click="handleQuarterShow">
      <span class="tit_message">{{formatFormData.quarterName}}</span>
      <span class="img_box">
        <img src="@/assets/appraise/ic_jiantou_down  2@2x.png" alt />
      </span>
    </div>
    <div class="content">
      <div class="refresh">
        <div class="title">
          本季度填报功能
        </div>
        <div class="desc">
          全部刷新本季度投诉数据，刷新后可能会引起考核分数变化
        </div>
        <div class="btn">
          <van-button :disabled="isdisabled" type="primary" size="large" color="#36B374" @click="handleRefresh">刷新</van-button>
        </div>
      </div>
    </div>
    <common-picker
      ref="commonPickerQuarter1"
      :typeList="quarterList"
      :cols="1"
      @getTypeValue="handleQuarterValue"
    ></common-picker>
  </div>
</template>

<script>
import api from '../../../service/modules/appraiseNew';
import commonPicker from "../../../components/base/commonPicker.vue";
export default {
  components: {
    commonPicker
  },
  data() {
    return {
      quarterList: [], // 季度列表
      formData: {
        quarterName: '', // 季度名称
        quarterValue: '',
      },
      isdisabled: false,
    };
  },
  computed: {
    formatFormData() { // 格式化查询条件
      if (!this.formData.quarterValue) {
        const currentData = new Date();
        const currentYear = currentData.getFullYear();
        const currentMonth = currentData.getMonth();
        const currentQuarter = Math.floor(currentMonth / 3) + 1;
        const arr1 = new Array('一', '二', '三', '四');
        return {
          year: currentYear,
          quarter: currentQuarter,
          quarterName: `${currentYear}年第${arr1[currentQuarter - 1]}季度`
        }
      }
      const arr2 = this.formData.quarterValue.split('-');
      return {
        year: arr2[0],
        quarter: arr2[1],
        quarterName: this.formData.quarterName
      }
    },
    formatFormDataCopy() {
      const data = JSON.parse(JSON.stringify(this.formatFormData));
      delete data.quarterName;
      return data;
    },
  },
  async created() {
    // 初始化季度列表
    const defaultSelect = await this.initQuarterList();
    // 初始化季度选择器的值
    this.formData.quarterName = Object.values(defaultSelect)[0];
    this.formData.quarterValue = Object.keys(defaultSelect)[0];
  },
  methods: {
    // 初始化季度列表
    initQuarterList() {
      return new Promise((resolve, reject) => {
        api.getQuarters().then(res => {
          if (!res.data.length) reject('无季度数据');
          const quarterList = res.data.map(item => {
            const keys = Object.keys(item)
            return {
              code: keys[0],
              text: item[keys[0]],
            }
          })
          this.quarterList = [quarterList.reverse()];
          resolve(res.data[res.data.length - 1])
        }).catch(e => {
          reject(e);
        })
      })
    },
    // 设置年份季度
    handleQuarterValue(value) {
      this.formData.quarterName = value[0].text;
      this.formData.quarterValue = value[0].code;
    },
    // 刷新
    handleRefresh() {
      this.isdisabled = true;
      api.getComplainData(this.formatFormDataCopy).then(res => {
        this.$Toast.success('刷新成功!')
        this.isdisabled = false;
      }).catch(err=>{
        this.$Toast.fail('刷新失败');
         this.isdisabled = false;
      });
    },
    // 展示季度选择器
    handleQuarterShow() {
      this.$refs.commonPickerQuarter1 && this.$refs.commonPickerQuarter1.showPicker();
    },
  }
};
</script>

<style scoped lang="less">
.complaint_manage {
  padding: 0 12px;
  // background-color: #fbfbfb;
  & > .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0 12px;
  }
  .tit_message {
    display: inline-block;
    width: 148px;
    font-size: 20px;
    color: #333;
    font-weight: 500;
  }
  .img_box {
    display: inline-block;
    width: 200px;
  }
  img {
    display: inline-block;
    width: 6px;
    height: 4px;
    vertical-align: middle;
  }
  .content {
    .refresh {
      padding: 16px;
      height: 142px;
      box-shadow:0px 2px 15px 0px rgba(0,0,0,0.06);
      border-radius:3px;
      .title {
        margin: 8px 0 12px;
        color: #333;
        font-size: 14px;
        font-weight: 500;
      }
      .desc {
        margin-bottom: 24px;
        font-size: 12px;
        color: #666;
      }
      .btn .van-button {
        width: 319px;
        height: 40px;
        font-size: 16px;
      }
    }
  }
}
</style>